import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  category: {
    id: 'views.PressRoomArticleView.PressRoomArticle.ArticleHeader.category',
    defaultMessage: 'Kategoria:'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/ArtricleDetailPage/components/Article/ArticleHeader/ArticleHeader.intl.js